export default function TripsFooter() {
  return (
    <div className="mt-10 mb-10 || text-black222">
      <p className="text-c14  ">
        Can't find your reservation here?
        <a
          className="underline text-black font-semibold "
          href="https://www.airbnb.com/help?audience=guest"
          target="_blank"
        >
          {" "}
          Visit the Help Center
        </a>
      </p>
    </div>
  );
}
